import { isBrowser as r } from "./ghl-ui.es1144.js";
const i = r && "chrome" in window;
r && navigator.userAgent.includes("Firefox");
const e = r && navigator.userAgent.includes("Safari") && !i;
export {
  i as isChrome,
  e as isSafari
};
